/** @file This is the grading unit for continuous rubric. */
import { exactly } from 'purify-ts/Codec';
import { expr } from '@codegrade/utils';
import { UIPrefsStore } from '@/store';
/** The model exported as namespace. */
export var ContinuousRubricGradingUnit;
(function (ContinuousRubricGradingUnit) {
    /** The identifier of the preference item. */
    ContinuousRubricGradingUnit.PREF_NAME = 'continuous_rubric_grading_unit';
    /** Default value of the preference. */
    ContinuousRubricGradingUnit.DEFAULT_VALUE = 'percentage';
    /** All possible values of the preference. */
    ContinuousRubricGradingUnit.codec = exactly('percentage', 'points');
    /**
     * Function to send a load request the preference.
     *
     * To "get" the value, use `get` instead.
     *
     * @returns The value of the preference.
     */
    ContinuousRubricGradingUnit.load = () => UIPrefsStore.loadUIPreference({ preference: ContinuousRubricGradingUnit.PREF_NAME });
    /**
     * Function to update the value of the preference.
     *
     * @param value The new value of the preference.
     * @returns The promise with an APIResult from the request.
     */
    ContinuousRubricGradingUnit.set = (value) => UIPrefsStore.patchUIPreference({
        preference: ContinuousRubricGradingUnit.PREF_NAME,
        value,
    });
    /**
     * Function to get the value of the preference.
     *
     * @returns The value of the preference.
     */
    ContinuousRubricGradingUnit.get = () => {
        const pref = UIPrefsStore.getUIPref()(ContinuousRubricGradingUnit.PREF_NAME, ContinuousRubricGradingUnit.codec);
        return expr.match(pref, 'status', {
            'not-loaded': () => ContinuousRubricGradingUnit.DEFAULT_VALUE,
            'not-present': () => ContinuousRubricGradingUnit.DEFAULT_VALUE,
            'not-valid': () => ContinuousRubricGradingUnit.DEFAULT_VALUE,
            valid: ({ value }) => value,
        });
    };
})(ContinuousRubricGradingUnit || (ContinuousRubricGradingUnit = {}));
